export default __webpack_public_path__ + "static/media/fraction.33db074c.svg";